export default 10000;
